<template>
    <div class="d-flex align-center justify-center cardSistemas">
            <v-row justify="center" no-gutters>
                <v-col
                    cols="4"
                    v-for="sistema in sistemas"
                    :key="sistema.id"
                    class="d-flex align-center justify-center">
                    <v-card
                        outlined
                        @click="acessar(sistema)"
                        class="item elevation-0 mt-10"
                        height="200px"
                        width="300px">
                        <v-card-text class="d-flex justify-center">
                            <az-container class="text-center">
                                <v-img :src="sistema.urlImagem"/>
                            </az-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
    </div>

</template>

<script>

    import {mapActions} from 'vuex'
    import {actionTypes, mutationTypes} from '@/core/constants'

    export default {
        name: 'Acessos',
        components: {},
        data() {
            return {
                sistemas: []
            }
        },
        created() {
            this.$store.commit(mutationTypes.COMUM.SET_ESCONDER_MENU)
        },
        async mounted() {
            const resultado = await this.buscarAcessosSistemas()
            if (resultado) {
                this.sistemas = resultado.items
            }
        },
        methods: {
            ...mapActions([
                actionTypes.ACESSO_SISTEMA.BUSCAR_ACESSOS_SISTEMAS
            ]),
            acessar(sistema) {
                if (sistema.nomeSistema === 'Patrimônio Intangível'){
                    this.$store.commit(mutationTypes.COMUM.SET_MOSTRAR_MENU)
                }
                window.location.replace(window.location.origin + sistema.rotaAcesso)
            }
        }
    }

</script>

<style scoped lang="stylus">

    .cardSistemas
        min-height 65vh

    .titulo
        font-size 35px
        padding-bottom 10px

    .subTitulo
        font-size 19px
        margin-bottom 0

    .imagem
        margin-left auto
        margin-right auto
        width 50px
        height 80px

    .item
        border-radius 10px
        border 1px solid lightgrey
</style>
